import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return ($setup.store.step > 1)
    ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.store.step--))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.text || 'Back'), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}